import { render, staticRenderFns } from "./qusetionnairepaper2.vue?vue&type=template&id=f277af16&scoped=true"
import script from "./qusetionnairepaper2.vue?vue&type=script&lang=js"
export * from "./qusetionnairepaper2.vue?vue&type=script&lang=js"
import style0 from "./qusetionnairepaper2.vue?vue&type=style&index=0&id=f277af16&prod&lang=less"
import style1 from "./qusetionnairepaper2.vue?vue&type=style&index=1&id=f277af16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f277af16",
  null
  
)

export default component.exports